module.exports = __webpack_public_path__ + "img/KSC02974.9898db73.jpg";